import React from 'react';
// import "../../assets/css/master.css";

import TemplateDashboard from "../../../components/TemplateDashboard";
import MatrizEstadosContent from './components/MatrizEstadosContent';

const MatrizEstados = () => {

    return (
        <>

            <TemplateDashboard>
                <MatrizEstadosContent />
            </TemplateDashboard>

        </>
    )
};

export default MatrizEstados;